module.exports = __webpack_public_path__ + "static/media/icon-write-completed.61635f69.svg";